import * as specialtyCodes from "./specialtyCodes";
import * as tableColumnTypes from "./tableColumnTypes";

export const DEFAULT_TABLE_COLUMNS = [
  tableColumnTypes.PROVIDER,
  tableColumnTypes.PROVIDER_PAYMENT_METHOD,
  tableColumnTypes.PRACTICE_LICENSES,
  tableColumnTypes.ACTIVE_PATIENTS_LIMIT,
  tableColumnTypes.REMAINING_CAPACITY,
  tableColumnTypes.ACTIONS,
];

export const TABLE_COLUMNS_BY_SPECIALTY = {
  [specialtyCodes.PRIMARY_CARE]: [
    ...DEFAULT_TABLE_COLUMNS,
  ],
  [specialtyCodes.MENTAL_HEALTH]: [
    tableColumnTypes.PROVIDER,
    tableColumnTypes.PROVIDER_PAYMENT_METHOD,
    tableColumnTypes.PROVIDER_LICENSES,
    tableColumnTypes.ACTIVE_PATIENTS_LIMIT,
    tableColumnTypes.REMAINING_CAPACITY,
    tableColumnTypes.ACCEPT_NEW_PATIENTS,
    tableColumnTypes.ACTIONS,
  ],
};
